"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypedPublisher = void 0;
class SinglePublisher {
    subscribers = [];
    on(subscriber) {
        this.subscribers.push(subscriber);
    }
    async publish(e) {
        const promises = this.subscribers.map(s => s(e));
        await Promise.all(promises);
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class TypedPublisher {
    map = {};
    async publish(k, e) {
        await this.map[k]?.publish(e);
    }
    on(k, subscriber) {
        let x = this.map[k];
        if (!x) {
            x = new SinglePublisher();
            this.map[k] = x;
        }
        x.on(subscriber);
    }
}
exports.TypedPublisher = TypedPublisher;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZWQtcHVibGlzaGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3R5cGVkLXB1Ymxpc2hlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFNLGVBQWU7SUFDWCxXQUFXLEdBQXVDLEVBQUUsQ0FBQTtJQUU1RCxFQUFFLENBQUMsVUFBMEM7UUFDM0MsSUFBSSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUE7SUFDbkMsQ0FBQztJQUVELEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBSTtRQUNoQixNQUFNLFFBQVEsR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO1FBQ2hELE1BQU0sT0FBTyxDQUFDLEdBQUcsQ0FBQyxRQUFRLENBQUMsQ0FBQTtJQUM3QixDQUFDO0NBQ0Y7QUFNRCw4REFBOEQ7QUFDOUQsTUFBYSxjQUFjO0lBQ1IsR0FBRyxHQUdoQixFQUVILENBQUE7SUFFRCxLQUFLLENBQUMsT0FBTyxDQUFvQixDQUFJLEVBQUUsQ0FBTztRQUM1QyxNQUFNLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFBO0lBQy9CLENBQUM7SUFFRCxFQUFFLENBQW9CLENBQUksRUFBRSxVQUE2QztRQUN2RSxJQUFJLENBQUMsR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFBO1FBQ25CLElBQUksQ0FBQyxDQUFDLEVBQUUsQ0FBQztZQUNQLENBQUMsR0FBRyxJQUFJLGVBQWUsRUFBUSxDQUFBO1lBQy9CLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFBO1FBQ2pCLENBQUM7UUFDRCxDQUFDLENBQUMsRUFBRSxDQUFDLFVBQVUsQ0FBQyxDQUFBO0lBQ2xCLENBQUM7Q0FDRjtBQXBCRCx3Q0FvQkMifQ==